<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body">
          <h1 class="heading-big mb-4">
            {{ $t('forgotPassword.recoverPassword') }}
          </h1>
          <f-alert
            v-if="authError"
            theme="danger"
            visible
            class="my-5">
            {{ $t('forgotPassword.errorAuth') }}
          </f-alert>

          <f-alert
            v-if="messageSentTxt.length"
            theme="success"
            visible
            class="my-5">
            {{ messageSentTxt }}
          </f-alert>

          <validation-observer
            ref="forgot-password-form"
            tag="form">
            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <div class="form-group">
                <label>Adres e-mail</label>
                <f-input
                  v-model="email"
                  name="email"
                  type="email"
                  class="full-width"
                  :state="errors.length ? 'invalid' : null"
                  :placeholder="$t('resetPassword.yourEmail')" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </div>
            </validation-provider>

            <f-button
              type="submit"
              theme="primary"
              class="full-width mt-1"
              big
              withArrow
              @click.prevent="submit"
              :disabled="submitting">
              {{ $t('forgotPassword.resetPassword') }}
            </f-button>
          </validation-observer>

          <div class="text-center mt-4">
            <router-link
              to="/logowanie"
              class="lnk lnk-big lnk-big-blue"
              :disabled="submitting">
              {{ $t('ui.backToLoginPage') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PasswordReset',
  data () {
    return {
      authError: false,
      submitting: false,
      email: '',
      messageSentTxt: ''
    }
  },
  methods: {
    submit () {
      this.authError = false;
      this.submitting = true;
      // delete this.$http.defaults.headers['X-Csrf-Token'];

      this.$http.post('/api/auth/password/email', {
        email: this.email
      }).then((response) => {
        this.submitting = false;
        this.messageSentTxt = response.data.message;
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>
